module.exports = __webpack_public_path__ + "static/media/Dwight D. Eisenhower (I) - 1956.0cfc3cdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Dwight D. Eisenhower (I) - 1956.jpg
// module id = 457
// module chunks = 0